import ErrorStatePage from './ErrorStatePage';

export default function NotFoundPage() {
    return <ErrorStatePage code="404" title="Página não encontrada" description="O endereço informado não existe ou foi movido para outra área." />;
}
